// ローカルストレージ管理ユーティリティ

const TOKEN_KEY = 'access_token';
const USER_KEY = 'current_user';

// トークンの保存
export const saveToken = (token: string): void => {
  localStorage.setItem(TOKEN_KEY, token);
};

// トークンの取得
export const getToken = (): string | null => {
  return localStorage.getItem(TOKEN_KEY);
};

// トークンの削除
export const removeToken = (): void => {
  localStorage.removeItem(TOKEN_KEY);
};

// ユーザー情報の保存
export const saveUser = (user: unknown): void => {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

// ユーザー情報の取得
export const getUser = <T>(): T | null => {
  const userStr = localStorage.getItem(USER_KEY);
  if (!userStr) return null;

  try {
    return JSON.parse(userStr) as T;
  } catch {
    return null;
  }
};

// ユーザー情報の削除
export const removeUser = (): void => {
  localStorage.removeItem(USER_KEY);
};

// 全データのクリア
export const clearStorage = (): void => {
  removeToken();
  removeUser();
};
